module.exports = __webpack_public_path__ + "static/media/UserWoman.6c21a8b6.svg";